/** Global "n" shortcut to focus the quick-add input (#quick-add-input). */
import { useEffect } from 'react';
import { focusQuickAddInput } from '@/hooks/ui/focusQuickAddInput';
import {
  isEditableFocused,
  isQuickAddFocusShortcut,
} from '@/constants/keyboardShortcuts';

export function useQuickAddFocusShortcut() {
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (!isQuickAddFocusShortcut(event)) return;
      if (isEditableFocused()) return;

      const quickAddInput = document.getElementById('quick-add-input');
      if (!(quickAddInput instanceof HTMLElement)) return;

      event.preventDefault();
      focusQuickAddInput();
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);
}
